import { PokerCard } from "./PokerCard";
import { DetailOpRow } from "./DetailOpRow";
import { stageLabel, fmtChips, displayChips } from "./helpers";

/**
 * StagePanel — réplica nativa de DetailStagePart (PPPoker Holdem History).
 * El `chipFactor` convierte raw → visual chips (heurística inferida).
 */
export function StagePanel({ round, playerByUid, isPreflop = false, totalBoardSlots = 5, chipFactor = 1, matchedUidSet }) {
  const stageName = stageLabel(round.stage, round.street);
  const boardAdded = round.board_display_labels || round.board_labels || round.board || [];
  const board2Added = round.board_2_display_labels || round.board_2_labels || round.board_2 || [];
  // Pot AL INICIO de la calle (preprocessed en NativeHandDetails: pot_label_chips).
  // Fallback al pot_end por compatibilidad.
  const potChips = round.pot_label_chips ?? round.pot_end_chips ?? round.pot_chips ?? round.pot_total_chips;
  const potRaw = round.pot_end_raw ?? round.pot_raw;
  const potSource = (potChips != null && Number(potChips) > 0) ? potChips : potRaw;
  const potVisual = displayChips(potSource, chipFactor);

  // Preflop NO muestra dorsos en el cliente nativo PPPoker — solo el label + acciones + pot.
  // Ref: comparación con cliente iOS PPPoker (mano 260509040536-7191603-0000148-1)

  return (
    <section
      className="border-b border-[#242936] last:border-b-0"
      data-testid={`stage-panel-${round.stage}`}
    >
      <div
        className="grid items-center gap-2 bg-[#1b1f2b] pl-2 pr-3 py-3"
        style={{ gridTemplateColumns: "130px minmax(0, 1fr) 84px" }}
      >
        <span
          className="text-[22px] font-extrabold leading-none text-[#f6f6f7] drop-shadow-[0_1px_1px_rgba(0,0,0,0.7)]"
        >
          {stageName}
        </span>

        <div
          className="flex flex-col items-start justify-center gap-1 min-w-0"
          data-testid={`stage-board-${round.stage}`}
        >
          {boardAdded.length > 0 && (
            <div className="flex items-center justify-center gap-1.5">
              {boardAdded.map((c, i) => (
                <PokerCard key={`b1-${i}`} slot={c} size={39} testId={`board1-card-${i}`} />
              ))}
            </div>
          )}
          {board2Added.length > 0 && (
            <div className="flex items-center justify-center gap-1.5">
              {board2Added.map((c, i) => (
                <PokerCard key={`b2-${i}`} slot={c} size={39} testId={`board2-card-${i}`} />
              ))}
            </div>
          )}
        </div>

        <span className="text-[20px] font-extrabold tabular-nums leading-none text-[#f4f4f7] text-right drop-shadow-[0_1px_1px_rgba(0,0,0,0.65)]">
          {fmtChips(potVisual)}
        </span>
      </div>

      <div className="flex flex-col bg-[#11131d]">
        {(round.actions || []).map((action, idx) => (
          <DetailOpRow
            key={`${round.stage}-${idx}-${action.uid || "x"}`}
            action={action}
            playerByUid={playerByUid}
            chipFactor={chipFactor}
            rowIndex={idx}
            matchedUidSet={matchedUidSet}
          />
        ))}
      </div>
    </section>
  );
}
